<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div>
      <Header />
    </div>

    <nav class="navbar">
      <div class="left"></div>
      <div class="right bold"></div>
    </nav>

    <div class="body">
      <h1>Bienvenido</h1>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";

export default {
  components: {
    Header,
  },
  computed: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {}
}
</script>
